import { fetchPcsVideosByUuid } from "../../utils";

/**
 * Retrieves the video data for a given video ID from the PCS video API.
 *
 * @async
 * @param {object} videoApi - The video API object containing the API URL and domain.
 * @param {string} videoID - The ID of the video to retrieve data for.
 * @returns {Promise<Array|null>} - Video ANS array, or null on failure.
 */
export const getVideoData = async (videoApi, videoID) => {
  const { videoApiUrl, domain } = videoApi;
  return fetchPcsVideosByUuid(videoApiUrl, { uuid: videoID, domain });
};

export const checkForForceLoad = liveConfigData => {
  return (
    !!liveConfigData?.forceAdditionalProperties?.forceLoadVideo ||
    !!liveConfigData?.forceAdditionalProperties?.youtubeVideoId
  );
};
